/* AP Buybox page-loader (Apollo, 2026-05-20)
   When `nss-buybox` is embedded on a non-product template (page, index),
   the default updateBuybox() bails to a full window.location redirect because
   `main` children count differs. This override does a scoped, in-place swap of
   ONLY the <nss-buybox> children — never touching anything else on the page.

   Activated only when the <nss-buybox> element carries data-page-template="1".
*/
(function () {
  function whenReady(cb) {
    var t = customElements.get && customElements.get('nss-buybox');
    if (t && t.prototype && t.prototype.updateBuybox) return cb(t);
    var tries = 0;
    var iv = setInterval(function () {
      tries++;
      var k = customElements.get && customElements.get('nss-buybox');
      if (k && k.prototype && k.prototype.updateBuybox) { clearInterval(iv); cb(k); }
      if (tries > 50) clearInterval(iv);
    }, 100);
  }

  whenReady(function (NssBuybox) {
    var orig = NssBuybox.prototype.updateBuybox;

    NssBuybox.prototype.updateBuybox = function (anchorEl) {
      // Only patch behaviour on page-embedded buyboxes
      if (!this.hasAttribute('data-page-template')) {
        return orig.call(this, anchorEl);
      }

      var self = this;
      try {
        var href = anchorEl.getAttribute('href');
        // resolve to absolute
        var url;
        try { url = new URL(href, window.location.origin); } catch (e) { url = new URL(href); }
        var fetchUrl = url.pathname + url.search;

        anchorEl.parentElement && anchorEl.parentElement.classList.add('nss-switcher-loading');

        fetch(fetchUrl).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newBuybox = doc.querySelector('nss-buybox');
          if (!newBuybox) {
            console.error('[AP] No <nss-buybox> in fetched PDP, falling back to navigation.');
            window.location = fetchUrl;
            return;
          }

          // Selectors to swap inside the current buybox (same as default updateBuybox)
          var SWAP = [
            '.nss-buybox__gallery',
            '#ProductJson',
            '.nss-buybox__summary-details',
            '.nss-buybox__summary-size',
            '.nss-buybox__summary-form-fields',
            '.nss-buybox__summary-controls',
            '.nss-buybox__summary-accordion',
            '.nss-buybox__sticky-wrapper',
            '.nss-buybox__limited-time-offer',
            '.nss-buybox__switcher-product'
          ];

          SWAP.forEach(function (sel) {
            // Remove any duplicate stale matches (defensive — should be only one)
            var matches = self.querySelectorAll(sel);
            var newEl = newBuybox.querySelector(sel);
            if (matches.length && newEl) {
              matches[0].replaceWith(newEl.cloneNode(true));
              for (var i = 1; i < matches.length; i++) { matches[i].remove(); }
            }
          });

          // Update nss-product-handle
          var newHandle = anchorEl.getAttribute('nss-buybox-option-product-handle');
          var oldHandle = self.getAttribute('nss-product-handle');
          if (newHandle) self.setAttribute('nss-product-handle', newHandle);

          // Update colour classes
          var nodes = self.querySelectorAll('[nss-product-color]');
          nodes.forEach(function (n) {
            if (oldHandle) n.classList.remove('nss-product-color-' + oldHandle);
            if (newHandle) n.classList.add('nss-product-color-' + newHandle);
          });

          // Update active nav item
          self.querySelectorAll('.nss-switcher-nav-item').forEach(function (n) {
            n.classList.remove('nss-switcher-nav-item-active');
          });
          if (anchorEl.parentElement) {
            anchorEl.parentElement.classList.add('nss-switcher-nav-item-active');
            anchorEl.parentElement.classList.remove('nss-switcher-loading');
          }

          // Wipe animation (background colour transition)
          var bg = anchorEl.getAttribute('nss-buybox-option-color-bg');
          var wipe = self.querySelector('.nss-section-wipe');
          var wipeInner = self.querySelector('.nss-section-wipe__inner');
          var wavePaths = self.querySelectorAll('.nss-section-wipe__wave path');
          if (wipe && wipeInner && bg) {
            clearTimeout(self.wipeOut);
            wipe.classList.remove('nss-anim-slide-in');
            wipeInner.style.backgroundColor = bg;
            wavePaths.forEach(function (p) { p.style.fill = bg; });
            // force reflow then re-add
            void wipe.offsetWidth;
            wipe.classList.add('nss-anim-slide-in');
            self.wipeOut = setTimeout(function () {
              wipe.classList.remove('nss-anim-slide-in');
              self.style.backgroundColor = bg;
            }, 1000);
          } else if (bg) {
            self.style.backgroundColor = bg;
          }

          // Re-init okendo widgets
          try {
            var oke = self.querySelector('[data-oke-widget]');
            if (oke && window.okeWidgetApi && window.okeWidgetApi.initWidget) {
              window.okeWidgetApi.initWidget(oke);
            }
            var stars = self.querySelector('[data-oke-star-rating]');
            if (stars && window.okeWidgetApi && window.okeWidgetApi.initWidget) {
              window.okeWidgetApi.initWidget(stars);
            }
          } catch (e) { /* okendo not present */ }

          // Restart any autoplay videos
          self.querySelectorAll('video[autoplay]').forEach(function (v) { try { v.play(); } catch (e) {} });

          // Re-cache element references on the custom element — the original updateBuybox
          // reassigns `this.elements.buyboxStickyBar` to the OLD detached node, leaving observers
          // attached to elements no longer in the DOM. Point it at the new in-DOM sticky bar.
          try {
            if (self.elements) {
              var newSticky = self.querySelector('.js-nss-buybox-sticky') || self.querySelector('.nss-buybox__sticky-wrapper .js-nss-buybox-sticky') || self.querySelector('.nss-buybox__sticky-wrapper');
              if (newSticky) self.elements.buyboxStickyBar = newSticky;
            }
          } catch (e) {}

          // Re-init internal handlers
          try { self.handleQuantitySelectors && self.handleQuantitySelectors(); } catch (e) {}
          try {
            var active = self.querySelector('.js-nss-quantity-selector.active') || self.querySelector('.js-nss-quantity-selector');
            if (active) active.click();
          } catch (e) {}
          try { self.handleSticky && self.handleSticky(); } catch (e) {}
          try { self.initStickyObservers && self.initStickyObservers(); } catch (e) {}
          try { self.quantityHandlers && self.quantityHandlers(); } catch (e) {}
          try { self.subscriptionsHandler && self.subscriptionsHandler(); } catch (e) {}
          try { self.flickityInstance = null; self.initialiseGallerySlider && self.initialiseGallerySlider(); } catch (e) {}
          try { self.handleModal && self.handleModal(); } catch (e) {}

          // Re-attach forms for carousels (mirrors default behaviour)
          try {
            document.querySelectorAll('nss-carousel').forEach(function (c) {
              if (window.NSS_ATTACH_FORMS) window.NSS_ATTACH_FORMS(c);
            });
          } catch (e) {}

          // Hide selling_plan + variant fields (cosmetic — match default behaviour)
          try {
            var sp = self.querySelector('[name="selling_plan"]');
            var idF = self.querySelector('[name="id"]');
            if (sp) sp.style.display = 'none';
            if (idF) idF.style.display = 'none';
          } catch (e) {}

        }).catch(function (err) {
          console.error('[AP] Buybox in-place swap failed, navigating instead.', err);
          window.location = fetchUrl;
        });
      } catch (err) {
        console.error('[AP] updateBuybox override error, falling back.', err);
        return orig.call(self, anchorEl);
      }
    };

    console.log('[AP] Page-template buybox loader installed.');
  });
})();
